import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <div id="offer" className="bg-midnight-800 pb-24 pt-12" data-id="element-84">
      <Section className="max-w-3xl" data-id="element-85">
        <div className="bg-gradient-to-b from-[rgba(255,255,255,0.04)] to-[rgba(255,255,255,0.01)] rounded-[24px] p-8 md:p-12 border border-accent-blue/30 shadow-[0_0_50px_rgba(15,23,41,0.5)] relative overflow-hidden backdrop-blur-sm" data-id="element-86">
          {/* Glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-accent-blue/10 blur-[60px]" data-id="element-87" />

          <div className="relative z-10 text-center space-y-8" data-id="element-88">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-white tracking-wide" data-id="element-89">
              Recupera tus noches hoy
            </h2>

            <div className="flex flex-col items-center justify-center space-y-2" data-id="element-90">
              <span className="text-slate-300/40 line-through text-xl" data-id="element-91">
                $17 USD
              </span>
              <div className="flex items-baseline gap-1" data-id="element-92">
                <span className="text-6xl font-bold text-accent-blue" data-id="element-93">$6</span>
                <span className="text-3xl font-bold text-accent-blue" data-id="element-94">.36</span>
                <span className="text-xl text-white font-medium ml-1" data-id="element-95">USD</span>
              </div>
              <span className="bg-accent-blue/10 text-accent-blue px-3 py-1 rounded-full text-sm font-medium border border-accent-blue/20" data-id="element-96">
                Oferta de lanzamiento
              </span>
            </div>

            <div className="space-y-4 pt-4" data-id="element-97">
              <Button fullWidth className="text-xl py-6 shadow-accent-blue/20" href="https://cuerpoencalma.it.com/cart/47459892756667:1" data-id="element-98">
                Sí, quiero el Protocolo 3AM
              </Button>
              <p className="text-sm text-slate-400/60 flex items-center justify-center gap-2" data-id="element-99">
                <Lock className="w-3 h-3" data-id="element-100" /> Pago seguro y encriptado
              </p>
            </div>

            <div className="pt-8 border-t border-[rgba(255,255,255,0.08)] mt-8" data-id="element-101">
              <div className="flex flex-col items-center gap-4" data-id="element-102">
                <ShieldCheck className="w-12 h-12 text-slate-400/30" data-id="element-103" />
                <h3 className="font-bold text-white" data-id="element-104">Garantía de 14 noches</h3>
                <p className="text-slate-300/70 text-sm max-w-md mx-auto" data-id="element-105">
                  Si aplicas el protocolo durante 14 noches y sientes que no te
                  dio claridad ni control, te devolvemos el 100% de tu dinero.
                  Sin preguntas incómodas.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center space-y-4" data-id="element-106">
          <p className="text-slate-400/40 text-sm" data-id="element-107">
            Este producto es digital. Recibirás acceso inmediato a tu correo
            electrónico después de la compra.
          </p>
          <p className="text-slate-400/20 text-xs" data-id="element-108">
            © 2024 El Protocolo 3AM. Todos los derechos reservados. <br data-id="element-109" />
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </Section>
    </div>;
}